import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Row, Table, Select, Input, Spin, Modal } from 'antd';
import { t } from 'i18next';
import { Button } from '../components/buttons/buttons';
import formHelper from '../utility/formHelper';
import { DataService } from '../config/dataService/dataService_yerbis';
import { SpinerCustomStyle } from '../container/styled';

function ProjeDurumDegistir({ visible, onCancel }) {
  const [form] = Form.useForm();
  const { Option } = Select;

  const [projeDurumlari, setProjeDurumlari] = useState([]);
  const [loading, setLoading] = useState(true);

  const getProjeDurumlari = async () => {
    const res = await DataService.post(`${process.env.REACT_APP_PROJE_DURUMLARI}`, { orderColumnAndDirection: '1' });
    setProjeDurumlari(res.data.model);
  };

  const updateDurum = async () => {
    setLoading(true);
    const values = formHelper.getFormValues(form);
    if (!formHelper.isEmptyFieldVal(values)) {
      await formHelper.formSubmit(`${process.env.REACT_APP_PROJE_DURUM_DEGISTIR_ADMIN}`, values, 'post');
    }
    setLoading(false);
  };

  useEffect(() => {
    const operations = async () => {
      await getProjeDurumlari();
      setLoading(false);
    };
    operations();
  }, []);

  return (
    <Modal
      maskClosable={false}
      visible={visible}
      title={t('projeDurumuDegistirme.title')}
      footer={null}
      width="50%"
      onCancel={onCancel}
    >
      {loading && (
        <SpinerCustomStyle>
          <Spin />
        </SpinerCustomStyle>
      )}
      <Row gutter={25}>
        <Col xs={24}>
          <Form form={form} layout="vertical">
            <Col xs={24}>
              <Form.Item name="barkodNo" label={t('projeDurumuDegistirme.questions.q1')} className="input-sm">
                <Input style={{ padding: '6.5px 20px' }} />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item name="yeniDurum" label={t('projeDurumuDegistirme.questions.q2')} className="input-sm">
                <Select
                  className="ninjadash-fullwidth-select"
                  showSearch
                  getPopupContainer={(trigger) => trigger.parentNode}
                  optionFilterProp="children"
                >
                  <Option value="">{t('select')}</Option>
                  {projeDurumlari?.map((item) => (
                    <Option value={item.Numarasi}>{item.Adi}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Row justify="center">
              <Button
                onClick={() => {
                  updateDurum();
                }}
                type="success"
                size="default"
              >
                {t('projeDurumuDegistirme.button')}
              </Button>
            </Row>
          </Form>
        </Col>
      </Row>
    </Modal>
  );
}

ProjeDurumDegistir.propTypes = {
  onCancel: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default ProjeDurumDegistir;
